import { sendRequest } from "../request";
const BASE_URL = '/api/projectsTimeline';

export function getProjects(user) {
    return sendRequest(`${BASE_URL}/getProjects/${user._id}`);
}
